import { type ComponentProps, forwardRef } from 'react';

import { ChevronDownIcon, ChevronUpIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type ColorDropdownPickerTriggerProps = ComponentProps<'button'> & {
  hex: string;
  isOpen: boolean;
};

export const ColorDropdownPickerTrigger = forwardRef<HTMLButtonElement, ColorDropdownPickerTriggerProps>(
  ({ className, hex, isOpen, ...restOfProps }, ref) => (
    <button
      {...restOfProps}
      className={cn(
        'flex w-fit max-w-full items-center gap-1.5 rounded-full border border-gray-5 ads:bg-base bg-gray-1 px-2.5 py-1 ads:text-primary text-12 text-gray-12 hover:ads:border-strong hover:border-gray-6 focus-visible:outline-none focus-visible:ads:ring-focus focus-visible:ring-2 focus-visible:ring-blue-8',
        className,
      )}
      data-testid="COLOR_DROPDOWN_PICKER"
      ref={ref}
      type="button"
    >
      <span
        aria-hidden
        className="size-3.5 shrink-0 rounded-full border ads:border-strong border-gray-6"
        style={{ backgroundColor: hex }}
      />
      <span className="min-w-0 truncate">{hex}</span>
      {isOpen ? (
        <ChevronUpIcon className="shrink-0 ads:text-icon-default text-gray-10" size="sm" />
      ) : (
        <ChevronDownIcon className="shrink-0 ads:text-icon-default text-gray-10" size="sm" />
      )}
    </button>
  ),
);

ColorDropdownPickerTrigger.displayName = 'ColorDropdownPickerTrigger';
